import { ReportRetryRequest, ReportsApi } from '@/modules/shared/adapter';
import { ReportsRepository } from '@/modules/ctx-documents/adapter/ReportsRepository';
import { ReImportSpecification } from '@/clients/dashboardapi/v2';

export class ReportRepositoryImpl implements ReportsRepository {
    private readonly reportsApi: ReportsApi;

    constructor(apis: {
        reports: ReportsApi;
    }) {
        this.reportsApi = apis.reports;
    }

    public async retryReport(reportRetryRequest: ReportRetryRequest): Promise<void> {
        return await this.reportsApi.retryReport(reportRetryRequest);
    }

    public async getAffectedReImportSpecifications(documentKeys?: string[], dashboardKey?: string): Promise<{ [key: string]: ReImportSpecification[]; }> {
        return await this.reportsApi.getAffectedReImportSpecifications(documentKeys, dashboardKey);
    }
}
